<div class="position-reletivediv">
  <div class="popup-inner-space">
    <div class="betweenheader"> Send Email </div>
    <div class="text-right flow-right">
      <img src="assets/images/close.svg" id="close" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close();">
    </div>
  </div>
  <form [formGroup]="EmailForm" (ngSubmit)="SendEmail()" id="SendEmail" class="popup-inner-space">
    <div class="fxg-field input-field-w input-field-sigiup">
      <div class="fxg-field  margin-top-20 email-field-space">
        <input formControlName="Email" id="Email" placeholder="Email" class="fxg-field__input-text fxg-field__input--required sessioncamexclude">
        <span class="fxg-field__placeholder fxg-field__floating-placeholder"
        tabindex="-1">Email Address</span>
        <div class="main-errormsg" *ngIf="displayMessage">
          {{displayMessage.Email}}
        </div>
      </div>
    </div>
    <div class="text-right margin-top-20">
      <button class="btncommon" type="submit" id="send">Send</button>
    </div>
  </form>
